import CloseCircleSolidSVG from "@design-system/ui-icons/vanilla/CloseCircleSolid"
import { createIcon } from "../createIcon"

export const CloseCircleSolidIcon = createIcon(CloseCircleSolidSVG)
